import { RefObject, useEffect, useRef } from 'react'
import { useIsInViewport } from '~/hooks/useIsInViewPort'

export function useInfiniteScroll(fetchMore: () => any, hasNextPage: boolean) {
  const bottomRef = useRef<HTMLDivElement>(null)
  const isAtBottom = useIsInViewport(bottomRef as RefObject<HTMLElement>)

  useEffect(() => {
    if (isAtBottom && hasNextPage) {
      void fetchMore()
    }
  }, [isAtBottom])

  return bottomRef
}
